import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export type { DevDocsBylineConnectionAncestor } from '../src/BylineConnections.tsx';

export const BylineConnections: LoadableType<any> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BylineConnections" */ '../src/BylineConnections.tsx'
			)
		).BylineConnections,
});
